import React from 'react';
import _ from 'lodash';
import { Replace } from '../../icons';
function onClick1(color, colorIndex) {
  this.onChange(color, colorIndex);
}
function onMouseEnter2(color, colorIndex) {
  this.props.onColorEnter(color, colorIndex);
}
function onMouseLeave3(color, colorIndex) {
  this.props.onColorLeave(color, colorIndex);
}
function repeatColor4(color, colorIndex) {
  return /*#__PURE__*/React.createElement("span", {
    onClick: onClick1.bind(this, color, colorIndex),
    onMouseEnter: onMouseEnter2.bind(this, color, colorIndex),
    onMouseLeave: onMouseLeave3.bind(this, color, colorIndex),
    className: 'palette-single-color-container ' + (this.props.value && this.state.colorIndex === colorIndex ? 'selected-color' : ''),
    key: colorIndex
  }, /*#__PURE__*/React.createElement("span", {
    className: 'palette-single-color ' + (this.getDistanceToWhite(color) < 3 ? 'light' : ''),
    style: {
      backgroundColor: color
    }
  }));
}
function onClick5(mainColor, mainColorIndex) {
  this.props.onMainColorChange(mainColor, mainColorIndex);
}
function onMouseEnter6(mainColor, mainColorIndex) {
  this.props.onColorEnter(mainColor, mainColorIndex);
}
function onMouseLeave7(mainColor, mainColorIndex) {
  this.props.onColorLeave(mainColor, mainColorIndex);
}
function repeatMainColor8(mainColor, mainColorIndex) {
  return /*#__PURE__*/React.createElement("span", {
    className: "palette-main-color-container",
    key: mainColorIndex
  }, /*#__PURE__*/React.createElement("span", {
    className: "palette-main-color",
    onClick: onClick5.bind(this, mainColor, mainColorIndex),
    onMouseEnter: onMouseEnter6.bind(this, mainColor, mainColorIndex),
    onMouseLeave: onMouseLeave7.bind(this, mainColor, mainColorIndex),
    style: {
      backgroundColor: mainColor
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: "change-main-color-arrow",
    style: {
      borderBottomColor: mainColor
    }
  }), /*#__PURE__*/React.createElement("span", {
    className: "change-main-color-icon"
  }, /*#__PURE__*/React.createElement(Replace, {
    color: "D6"
  }))));
}
export default function () {
  return React.createElement.apply(this, ['div', {
    className: this.props.getClassName('color-picker-palette'),
    dataHook: this.props.dataHook
  }, _.map(this.getColorsByPalette(this.props.palette), repeatColor4.bind(this)), _.map(this.props.mainColors, repeatMainColor8.bind(this))]);
}